import React from 'react';
import './Login.css';
import {Button} from '@material-ui/core';
import {auth,provider} from './firebase';
import {useStateValue} from './StateProvider';
import {actionTypes} from './reducer';
import web from '../src/images/google.png';
import slack from '../src/images/slack-logo.jpg';

const Login = () => {
	// eslint-disable-next-line
	const [state,dispatch] = useStateValue();

	const signIn = () => {
		auth
		.signInWithPopup(provider)
		.then((result) => {
			dispatch({
				type:actionTypes.SET_USER,
				user:result.user,
			})
		})
		.catch((error) => {
			alert(error.message);
		});
	}

    return (
        <div className='login'>
        	<div className='login__container'>
        		<img src={slack} alt=''/>
        		<h1>Sign in to Slack Clone</h1>
        		<Button onClick={signIn}><span className='google_logo'><img src={web} alt='' /></span><p>Sign in</p></Button>	
        	</div>
        </div>
    );
};

export default Login;
